import {DataFetcher} from '@aboutyou/data-fetcher';
import {ErrorPageInline} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {useImagesSection} from '../useGetProductBulkSection';
import {ProductImageGridLoading} from './ProductImageGridLoading';
import {
  ProductImageGridView,
  ProductImageGridViewProps,
} from './ProductImageGridView';
import {useComputeDefaultState} from './useComputeDefaultState';

export const ProductImageGrid: FC<ProductImageGridViewProps> = props => {
  const defaultState = useComputeDefaultState();

  return (
    <DataFetcher
      request={useImagesSection()}
      Error={ErrorPageInline}
      View={ProductImageGridView}
      Loading={ProductImageGridLoading}
      viewProps={props}
      computeDefaultState={() => defaultState}
    />
  );
};
